import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { getTelemetry } from '@cian/telemetry/browser';
import { createWidgetResultObserver } from '../createWidgetResultObserver';

export const getContext = () => {
  return {
    config: getConfig(),
    logger: getLogger(),
    httpApi: getHttpApi(),
    telemetry: getTelemetry(),
    widgetResultObserver: createWidgetResultObserver(),
  };
};
